import { css } from '@emotion/react';

import { BelfiusFont, CiutadellaFont } from './fonts';

export const reset = css`
  ${BelfiusFont}
  ${CiutadellaFont}

  *,
  *:after,
  *:before {
    box-sizing: inherit;
  }

  html {
    font-family: Inter, Helvetica Neue, sans-serif;
    height: 100%;
    font-size: 16px;
    overflow-y: scroll;
    overflow-x: hidden;
  }

  body {
    box-sizing: border-box;
    font-size: 16px;
    margin: 0;
    padding: 0;
    font-weight: 600;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p,
  button {
    font-family: Inter, Helvetica Neue, sans-serif;
    font-size: inherit;
    font-weight: inherit;
    line-height: inherit;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p,
  figure {
    margin: 0;
    padding: 0;
  }

  ul {
    margin: 0;
    padding: 0;
    list-style: none;
  }

  address {
    font-style: normal;
  }

  a {
    text-decoration: none;
  }

  button {
    border: none;
    box-shadow: none;
    cursor: pointer;
  }
`;

export default reset;
